export class EntRealEstateFilter {


  page: number
  size: number
  deleted: boolean

  codeEni: string | null
  street: string | null
  houseNumber: string | null
  squareFrom: number | null
  squareTo: number | null
  territorialUnitIds: number[] | null
  unitMeasurementIds: number[] | null
  typeObjectIds: number[] | null
  purposeObjectIds: number[] | null
  ownershipTypeIds: number[] | null
  landCategoryIds: number[] | null
  conditionIds: number[] | null
  governmentIds: number[] | null
  periodStart: string | null
  periodEnd: string | null
  
  constructor(init?:Partial<EntRealEstateFilter>) {
    this.codeEni = null;
    this.street = null;
    this.houseNumber = null;
    this.squareFrom = null;
    this.squareTo = null;
    this.territorialUnitIds = null;
    this.unitMeasurementIds = null;
    this.typeObjectIds = null;
    this.purposeObjectIds = null;
    this.ownershipTypeIds = null;
    this.landCategoryIds = null;
    this.conditionIds = null;
    this.governmentIds = null;
    this.periodStart = null;
    this.periodEnd = null;
    this.deleted = false;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}

